const urlString = location.href;
const url = new URL(urlString);

// 获取路径字符串
const pathSegments = url.pathname.split('/');

// 获取最后一项
const lastSegment = pathSegments[pathSegments.length - 1];

console.log(lastSegment, '当前商品')
const goods = [
  'pet-loss-urn-necklace-for-ashes-custom-jewelry-with-photo-pet-hair-locket-cat-fur-keepsake', // 圆型
  'custom-dog-portrait-tag-necklace', // 长方形
  // 'personalized-pet-portrait-necklace', // 多边形
  'custom-pet-photo-necklace ' , // 原来
  'locator-tag-bluetooth-tracker-with-protective-silicone-keychains'
]
let currentGoods = goods.find((i) => i === lastSegment)
if (currentGoods === 'locator-tag-bluetooth-tracker-with-protective-silicone-keychains') {
  currentGoods = 'custom-dog-portrait-tag-necklace'
}
console.log(currentGoods, '匹配商品')
// return 
// const cross = location.href.indexOf('locator-tag-bluetooth-tracker-with-protective-silicone-keychains') === -1
if (!currentGoods) {
  console.log('不符合条件商品不处理') 
} else {
  console.log('符合条件商品处理')
  const getImg = (src, petname = 'ipet') => {
    console.log(src)
    return new Promise((resolve, reject) => {
// https://api-ipet.gonest.cn/dataBoard/ipetImage?url=https://ucarecdn.com/cc206b4e-981b-43ac-b618-3d003ae6501e/-/resize/300x/&text=ipet&diameter=68&isRestricted=1&env=test
// `https://api-ipet.gonest.cn/dataBoard/ipetImage?url=${src}&text=ipet&diameter=68&isRestricted=1&env=test&templateId=${currentGoods}`
      fetch(`https://api-ipet.gonest.cn/dataBoard/ipetImage?url=${src}&text=${petname}&diameter=68&env=pro&isRestricted=1&templateId=${currentGoods}`)
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error('网络请求失败');
        }
      })
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      });
    })
  }
  console.log('g1')
  const appendSvg= (src) => {
    const goodsEle = document.querySelector('.main-product__media-gallery__inner-media[active] img')
    goodsEle.removeAttribute('srcset');
    goodsEle.setAttribute('style', 'height: 100%; width: 100%;');
    goodsEle.setAttribute('src', src)
  }

  console.log('g2')
  const getColor = () => {
    var inputElements = document.getElementsByName('Color');
    let current = 1
    for (var i = 0; i < inputElements.length; i++) {
        if (inputElements[i].checked) {
            console.log(i)
            current = i + 1
        }
    }
    return current
  }
  console.log('g3')
  
  const getToast = (type = true) =>{
    if (type) {
      const div = document.createElement('div')
      div.setAttribute('style', 'position: fixed; top: 20px; left: 50%; transform: translateX(-50%); padding: 15px; color: black; z-index: 9990; background: #fff; border-radius: 4px; box-shadow: 0 0 10px rgba(0,0,0,.1);')
      div.innerText = '正在AI生成图片中...'
      document.body.appendChild(div)
      div.setAttribute('id', 'toast')
    } else {
      document.getElementById('toast').remove()
    }
  }

  const appendBtn= async(src) => {
    const ele = document.querySelector('.uploadkit-thumbnails')
    // 创建一个新的元素
    var newElement = document.createElement("div");
    newElement.innerText = 'Generate'
    newElement.style = `
    background: #ff732b;
    width: 120px;
    line-height: 30px;
    text-align: center;
    border-radius: 4px;
    color: white;
    cursor: pointer;`
    newElement.onclick = async() => {
      console.log(111111122222)
      console.log('开始重新创建')
      const color = getColor()
      getToast()
      const petname = document.querySelector('.uploadkit-textarea').value
      const res = await getImg(src, petname)
      getToast(false)
      console.log(res, '-->>>返回')
      const url = res.data[`image${color}`]
      appendSvg(url)
    }
    // 在reference节点之前插入新元素
    ele.appendChild(newElement);
  }

  var isWork = false

  document.addEventListener('DOMContentLoaded', function() {
    console.log('g4')
    const parentElement = document.getElementsByClassName('uploadkit-thumbnails');
    console.log('g7', parentElement)
    const callback = function(mutationsList, observer) {
      console.log('g6')
      for (const mutation of mutationsList) {
        const t1 = mutation.type
        const isNode = t1 === 'childList'
        if (isNode) {
          mutation.addedNodes.forEach(async node => {
            const cs = node.getAttribute('class');
            if (cs === 'uploadkit-thumbnail') {
              if (!isWork) {
                isWork = true
                console.log(cs)
                const src = node.getAttribute('src')
                const color = getColor()
                getToast()
                const res = await getImg(src)
                getToast(false)
                console.log(res, '-->>>返回')
                const url = res.data[`image${color}`]
                appendSvg(url)
                appendBtn(src)
                isWork = false
              }
            }
          });
        }
      }
    };
  
    const observer = new MutationObserver(callback);
  
    const config = { childList: true, subtree: true };
    for (let i in parentElement) {
      const nd = parentElement[i]
      observer.observe(nd, config);
    }
  });
}